import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "@/components/site/Motion";

const FAQ = [
  { q: "Var lagras min information som jag sparar i Redoc?", a: "All information/data lagras på server i ett högsäkerhetsklassat datacenter i Sverige." },
  { q: "Hur är kapaciteten till servern där min information lagras?", a: "Servern är ansluten till ett av Europas största och kraftigaste stamnät vilket ger snabba svarstider och hög tillgänglighet. Anslutningen sker via fiber med redundans och geografisk diversitet (anslutning från olika geografiska platser)." },
  { q: "Är anslutningen säker?", a: "All kommunikation med servern sker krypterat med SSL-certifikat." },
  { q: "Behöver jag installera programvara på min dator?", a: "Nej, allting finns molnbaserat och nås via Din webbläsare." },
  { q: "Kan jag använda Redoc på surfplatta eller mobil?", a: "Ja, tjänsten är \"responsive\" så det går lika bra att använda Redoc på surfplatta som på mobilen." },
  { q: "Vilken webbläsare kan jag använda?", a: "Vi rekommenderar Chrome, men även andra webbläsare fungerar." },
  { q: "Vad har Ni för bindningstid?", a: "Minsta bindningstid för våra abonnemang är ett år, som förlängs automatiskt med ett år om uppsägning inte sker senast 30 dagar före pågående abonnemangs utgång." },
  { q: "Hur gör jag om jag har fler än 50 användare?", a: "Om Ni behöver abonnemang för fler än 50 användare, kontakta oss så ger vi Er en offert." },
];

export const Faq = () => (
  <div id="faq" className="mt-12 lg:pt-12 lg:mt-0">
  <Reveal>
    <div data-testid="faq-section">
      <Eyebrow>FAQ</Eyebrow>
      <h3 className="font-display text-3xl sm:text-4xl font-bold tracking-[-0.03em] mt-3">Vanliga frågor om Redoc</h3>
      <Accordion type="single" collapsible className="mt-6 border-t border-[#D8D7CE]">
        {FAQ.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} className="border-b border-[#D8D7CE]">
            <AccordionTrigger className="text-left font-semibold text-[16px] text-[#070B2E] hover:no-underline hover:text-[#0B14A0] py-5" data-testid={`faq-question-${i}`}>
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[15px] leading-relaxed text-[#3A3F5C] pr-6" data-testid={`faq-answer-${i}`}>
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </Reveal>
  </div>
);
